// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8009d951","427":"bd2f8296","436":"7ea7e56d","910":"ec1364c4"}[chunkId] + ".chunk.js";
};